export class Globals {
	public static BASE_URL: string = 'https://www.qf.org.qa';
	public static CURRENT_LANGUAGE_PREFIX: string = 'en';
	public static SITE_FIRST_LOAD: boolean = true;
}
